module.exports = __webpack_public_path__ + "static/media/wizualizacja-57.e341437e.png";